module.exports = __webpack_public_path__ + "img/router_shopee.5e36532e.png";